import type { CSSProperties, ReactNode } from "react";

type RuntimeBottomPaddingAttributes = { style: CSSProperties };

interface RuntimeBottomPaddingProps {
  padding: number;
  children: (attributes: RuntimeBottomPaddingAttributes) => ReactNode;
}

/** Contains bottom padding calculated from live layout measurements. */
export function RuntimeBottomPadding({ padding, children }: RuntimeBottomPaddingProps): ReactNode {
  return children({ style: { paddingBottom: padding } });
}
